var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slice',[_c('b-container',{staticClass:"slice-text",attrs:{"fluid":""}},[_c('b-container',{staticClass:"wrapper"},[_c('TextView',{attrs:{"text":_vm.content}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }